import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { Criterion } from './criterion'
import { CriterionService } from './criterion.service'

@Injectable()
export class SortService {
  items = []

  constructor(
    private cs: CriterionService
  ) { }


  highlightSortHits(dbr: DbRecord, txt: string) {
    if (!this.cs.currentCriterion || !txt)
      return txt
    this.cs.currentCriterion.getSortHits(dbr).forEach((ci) =>
        txt = txt.replace(ci._regexp,'<span class="criterionHit">$&</span>'))
    return txt
  }

  run(ls: DbRecord[]): DbRecord[] {
    if (!this.items.length)
      return ls

    ls.map((x, i) => x._position = i)
    ls.sort((a, b) => {
      let aTuple = a.sortTuple(this.items)
      let bTuple = b.sortTuple(this.items)

      for (var i = 0; i < this.items.length; i++)
        if (aTuple[i] < bTuple[i])
          return -1
        else if (aTuple[i] > bTuple[i])
          return 1

      return a._position < b._position ? -1 : 1;
    })
    return ls
  }

  switch(tp: string, forSecondary: boolean): void {
    if (forSecondary) {
      let i = this.items.indexOf(tp)
      if (i > -1)
        this.items.splice(i, 1)
      else
        this.items.push(tp)
    } else if (!this.items.length || this.items[0] != tp)
      this.items = [tp]
    else
      this.items = []
    this.cs.currentCriterion = null
    if (!this.items.length)
      return
    let c = this.cs.get(this.items[0])
    if (c)
      this.cs.currentCriterion = c
  }

  position(tp: string): number {
    return this.items.indexOf(tp)
  }

}



// WEBPACK FOOTER //
// ./src/app/sort.service.ts